module.exports = __webpack_public_path__ + "img/close.71bb1c74.svg";